import '@/components/assistant/assistant-print.css'
import {useAssistantStore} from '@/stores/assistant'
import {useI18n} from 'vue-i18n'

const PRINT_MODE_CLASS = 'assistant-print-mode'
const SINGLE_MESSAGE_PRINT_MODE_CLASS = 'assistant-single-message-print-mode'
const SINGLE_MESSAGE_PRINT_TARGET_CLASS = 'assistant-single-message-print-target'

export function useAssistantMessagePrint() {
  const {t} = useI18n()
  const assistantStore = useAssistantStore()

  let originalDocumentTitle: string | null = null

  function resolvePrintTitle() {
    const title = assistantStore.activeConversation?.title
    return title || t('assistant.untitled')
  }

  function applyPrintTitle() {
    if (originalDocumentTitle === null) {
      originalDocumentTitle = document.title
    }

    document.title = resolvePrintTitle()
  }

  function restoreDocumentTitle() {
    if (originalDocumentTitle === null) {
      return
    }

    document.title = originalDocumentTitle
    originalDocumentTitle = null
  }

  function printMessage(element: HTMLElement) {
    const printContent = element.closest('.assistant-print-content')
    if (!printContent) return

    let target: HTMLElement | null = element
    while (target && target.parentElement !== printContent) {
      target = target.parentElement
    }

    if (!target) return

    target.classList.add(SINGLE_MESSAGE_PRINT_TARGET_CLASS)
    document.body.classList.add(PRINT_MODE_CLASS, SINGLE_MESSAGE_PRINT_MODE_CLASS)
    applyPrintTitle()

    const cleanup = () => {
      target!.classList.remove(SINGLE_MESSAGE_PRINT_TARGET_CLASS)
      document.body.classList.remove(PRINT_MODE_CLASS, SINGLE_MESSAGE_PRINT_MODE_CLASS)
      restoreDocumentTitle()
      window.removeEventListener('afterprint', cleanup)
    }

    window.addEventListener('afterprint', cleanup)
    window.print()
  }

  return {printMessage}
}
